import { useState } from 'react'
import { X } from 'lucide-react'

// AS.Groups.create accepts only `name` (max 50 chars).
// AS.Group.edit accepts only `name` (no status, no descr).
// AdSpeed dashboard is the only way to change group status.
export default function GroupEditor({ initial = null, onClose, onSubmit }) {
  const isEdit = !!initial
  const [name, setName] = useState(initial?.name || initial?.Name || '')
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState('')

  async function handleSubmit(e) {
    e.preventDefault()
    setError('')
    if (!name.trim()) return setError('Name is required')
    if (name.trim().length > 50) return setError('Name must be ≤ 50 characters (AdSpeed limit)')

    setSaving(true)
    try {
      await onSubmit({ name: name.trim() })
    } catch (err) {
      setError(err.message)
    }
    setSaving(false)
  }

  return (
    <div
      className="modal-overlay"
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)',
        display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 100,
      }}
    >
      <div
        onClick={e => e.stopPropagation()}
        style={{
          background: '#121212', border: '1px solid #333', borderRadius: 10,
          padding: 24, minWidth: 440, maxWidth: 560,
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 16 }}>
          <h2 style={{ margin: 0, fontSize: '1.2rem' }}>
            {isEdit ? 'Edit Group' : 'New Group'}
          </h2>
          <button onClick={onClose} style={{ background: 'none', border: 'none', color: '#aaa', cursor: 'pointer' }}>
            <X size={18} />
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 12 }}>
            <label style={{ display: 'block', fontSize: '0.85rem', color: '#aaa', marginBottom: 4 }}>
              Name <span style={{ color: '#666' }}>(max 50 chars)</span>
            </label>
            <input
              autoFocus
              value={name}
              onChange={e => setName(e.target.value)}
              className="zones-search"
              style={{ width: '100%' }}
              maxLength={50}
              placeholder="e.g. PIHL-2026-Sponsors"
            />
          </div>

          {isEdit && (
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', fontSize: '0.85rem', color: '#aaa', marginBottom: 4 }}>
                Status
              </label>
              <div className="muted" style={{ fontSize: '0.85rem', padding: '6px 10px', background: '#1a1a1a', borderRadius: 4, border: '1px solid #333' }}>
                Current: <strong>{initial?.status || initial?.Status || 'unknown'}</strong>
              </div>
              <div className="muted" style={{ fontSize: '0.72rem', marginTop: 4 }}>
                Group status (active/pending/archived/deleted) cannot be
                changed via AdSpeed's API — only through the AdSpeed dashboard.
              </div>
            </div>
          )}

          {error && (
            <div className="sponsors-status error" style={{ marginBottom: 12 }}>{error}</div>
          )}

          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
            <button type="button" onClick={onClose} className="sponsors-refresh-btn">
              Cancel
            </button>
            <button type="submit" disabled={saving} className="btn btn-primary">
              {saving ? 'Saving…' : (isEdit ? 'Save' : 'Create')}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}
